import React from 'react';
import HighlightText from './HighlightText'; 
import knowYourProgress from '../../../assets/Images/Know_your_progress.svg';
import compayreWithAthors from '../../../assets/Images/Compare_with_others.svg';
import planYourLessons from '../../../assets/Images/Plan_your_lessons.svg'; 
import CTAButton from './Button'; 

const LearningLanguageSection = () => {
    return (
        <div>
            <div className='flex flex-col lg:mt-10 w-11/12 max-w-maxContent mx-auto pb-14'>
                <h3 className='md:text-4xl text-3xl font-semibold text-center'>
                    Your Swiss Knife for <HighlightText text={'learning any language'} />
                </h3>
                <p className='text-center text-richblack-700 mx-auto text-base font-medium leading-6 lg:w-[70%] mt-3'>
                    Using spin making learning multiple languages easy. with 20+ languages realistic voice-over, progress tracking, custom schedule and more.
                </p>
                <div className='flex lg:flex-row flex-col items-center justify-center mt-5'>
                    <img
                        src={knowYourProgress}
                        alt='knowYourProgress'
                        loading='lazy'
                        className='object-contain lg:-mr-36'
                    />
                    <img
                        src={compayreWithAthors}
                        alt='compareWithAthors'
                        loading='lazy'
                        className='object-contain -mb-8'
                    />
                    <img
                        src={planYourLessons}
                        alt='planYourLessons'
                        loading='lazy'
                        className='object-contain lg:-ml-36 lg:-mt-8 mt-0'
                    />
                </div>
                <div className='flex justify-center mt-5'>
                    <CTAButton linkTo={'/login'} active={true}>Learn More</CTAButton>
                </div>
            </div>
        </div>
    );
};

export default LearningLanguageSection;